import AppUpdateNotification from './components/appNotification';
import { DEFAULTDEALER_NAME } from '../../config';
import DialogModal from 'src/components/ui/dialogModal';
import { getPermissionsMap } from '../../utils/helpers';
import InactivityModal from './components/inactivityModal';
import { initializeDealer } from './utils/helpers';
import { isNavigationAvailable } from './utils/helpers';
import { IUser } from '../../utils/interfaces/user';
import ModalComponent from '../ui/modal';
import { NavigationMenu } from './components/navigationMenu';
import Routes from '../../routes';
import Spinner from '../ui/spinner';
import { TopBar } from './components/topBar';
import {
    INACTIVITY_TIMEOUT,
    refreshToken,
    startSessionTimeout,
} from '../../utils/session.helpers';
import React, { useEffect, useRef, useState } from 'react';

import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import './styles.scss';

const Dashboard = () => {
    const dispatch = useDispatch();
    const username = useSelector((state: IUser) => {
        return state.username;
    });
    const dealer = useSelector((state: IUser) => {
        return state.currentDealers?.default;
    });
    const accessUser = useSelector((state: IUser) => {
        return state.accessUser;
    });
    const selectedDistrict = useSelector((state: IUser) => {
        return state.selectedDistrics;
    });
    const [refreshTimer, setRefreshTime] = useState<NodeJS.Timeout | null>(
        null,
    );
    const [open, setOpen] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(() => {
        if (dealer) return true;
        const storedDealer = sessionStorage.getItem(DEFAULTDEALER_NAME);
        return (
            !!storedDealer &&
            storedDealer !== '' &&
            storedDealer !== 'undefined' &&
            storedDealer !== 'null'
        );
    });

    const inactivityTimerID = useRef<NodeJS.Timeout | null>(null);
    const lastActivityTime = useRef(Date.now());
    const inactivityModalRef = useRef<{ startLogoutTimer: () => void } | null>(
        null,
    );

    const resetInactivityTimer = () => {
        if (inactivityTimerID.current) {
            clearTimeout(inactivityTimerID.current);
        }

        createTimeOut();
    };

    function createTimeOut() {
        const timerId = setTimeout(() => {
            setOpen(true);
            // Iniciar el temporizador de cierre de sesión cuando se abre el modal
            if (inactivityModalRef.current) {
                inactivityModalRef.current.startLogoutTimer();
            }
        }, INACTIVITY_TIMEOUT);
        inactivityTimerID.current = timerId;
        return timerId;
    }

    useEffect(() => {
        startSessionTimeout();
        refreshToken(username, dispatch, refreshTimer, setRefreshTime);
        createTimeOut();
        const _onMouseMove = () => {
            if (!open) {
                lastActivityTime.current = Date.now();
                resetInactivityTimer();
            }
        };
        window.addEventListener('mousemove', _onMouseMove);
        window.addEventListener('keydown', _onMouseMove);

        return () => {
            if (inactivityTimerID.current)
                clearTimeout(inactivityTimerID.current);
            if (refreshTimer) clearTimeout(refreshTimer);
            window.removeEventListener('mousemove', _onMouseMove);
            window.removeEventListener('keydown', _onMouseMove);
        };
    }, [username, dispatch]);

    function handlerCloseModal() {
        setOpen(false);
        lastActivityTime.current = Date.now();
        resetInactivityTimer();
    }

    useEffect(() => {
        if (dealer) {
            initializeDealer(dealer, dispatch, setLoading);
        }
    }, [dealer, accessUser]);
    const dialogModal = useSelector((state: IUser) => {
        return state.dialogModal;
    });
    const permissionsMap: Map<string, Array<string>> = getPermissionsMap();
    return (
        <div>
            <TopBar routes={Routes} permissionsMap={permissionsMap} />
            <AppUpdateNotification />
            <div className={'content'}>
                {isNavigationAvailable(accessUser, selectedDistrict, dealer) &&
                    !loading && (
                        <NavigationMenu
                            routes={Routes}
                            dealer={dealer}
                            permissionsMap={permissionsMap}
                        />
                    )}

                <div className={'content-view'}>
                    {!loading ? (
                        <Outlet />
                    ) : (
                        <div className={'loading-spinner-container'}>
                            <Spinner />
                        </div>
                    )}
                </div>
            </div>
            {!loading && (
                <ModalComponent
                    bodyContent={
                        <InactivityModal
                            open={open}
                            handlerOpen={handlerCloseModal}
                            ref={inactivityModalRef}
                        />
                    }
                    open={open}
                />
            )}
            {!loading && (
                <DialogModal
                    titleContent={dialogModal.titleContent}
                    bodyContent={dialogModal.bodyContent}
                    cancelBtnLabel={dialogModal.cancelBtnLabel}
                    confirmBtnLabel={dialogModal.confirmBtnLabel}
                    onCancelHandler={dialogModal.onCancelHandler}
                    onConfirmHandler={dialogModal.onConfirmHandler}
                    open={dialogModal.shouldShow}
                />
            )}
        </div>
    );
};

export default React.memo(Dashboard);
